import { Clock } from "lucide-react";
import { formatDateRange } from "utils";

const LeaveWorkflowCard = ({ workflow }) => {
    const {
        lve_type_name,
        date_from,
        date_to,
        lve_duration,
    } = workflow;

    return (
        <>
            <div className="flex items-center justify-between gap-2">
                <span className="text-[11px] text-slate-700 font-semibold uppercase tracking-wide dark:text-slate-100">
                    Type
                </span>

                <span
                    className={`flex items-center text-xs border status-indicator ${lve_type_name?.toLowerCase().replace(/\s+/g, "-")}`}
                >
                    {lve_type_name}
                </span>
            </div>

            <div className="grid grid-cols-2 gap-2">
                <div className="p-2 rounded-xl bg-slate-50 border min-w-0 dark-mode-card">
                    <span className="text-[10px] text-slate-700 font-semibold uppercase dark:text-slate-100">
                        From
                    </span>

                    <p className="text-[12px] font-semibold truncate dark:text-white">
                        {formatDateRange(date_from)}
                    </p>
                </div>

                <div className="p-2 rounded-xl bg-slate-50 border min-w-0 dark-mode-card">
                    <span className="text-[10px] text-slate-700 font-semibold uppercase dark:text-slate-100">
                        To
                    </span>

                    <p className="text-[12px] font-semibold truncate dark:text-white">
                        {formatDateRange(date_to)}
                    </p>
                </div>
            </div>

            <div className="flex items-center gap-2 text-[12px] text-slate-700">
                <Clock className="w-3.5 h-3.5 flex-shrink-0 dark:text-slate-100" />

                <span className="font-medium dark:text-slate-100">
                    {lve_duration} day{lve_duration > 1 ? "s" : ""}
                </span>
            </div>
        </>
    );
};

export default LeaveWorkflowCard;